module.exports = __webpack_public_path__ + "static/profit-loss-173972200203f1d795ebf70e27828d98.png";